(() => {
  const root = document.querySelector('[data-hpm-mobile-navigation]');
  if (!root) return;
  const trigger = root.querySelector('[data-hpm-category-open]');
  const overlay = root.querySelector('[data-hpm-category-overlay]');
  const drawer = root.querySelector('.hpm-mobile-category-drawer');
  const mobile = window.matchMedia('(max-width: 989px)');
  let previousOverflow = '';
  let previousFocus = null;
  let chatObserver = null;
  function chatActivator(chat) {
    return chat?.shadowRoot?.querySelector('button[part~="activator"]') ||
      chat?.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot?.querySelector('button[part~="activator"]');
  }
  function readableChat(chat) {
    const shadow = chat?.shadowRoot;
    if (!shadow) return;
    const runtime = shadow.querySelector('shopify-agent-runtime');
    const target = runtime?.shadowRoot || shadow;
    shadow.querySelector('#hpm-mobile-chat-readability')?.remove();
    if (target.querySelector('#hpm-mobile-chat-viewport')) return;
    const style = document.createElement('style');
    style.id = 'hpm-mobile-chat-viewport';
    style.textContent = '@media(max-width:749px){.panel{position:fixed!important;top:calc(var(--hpm-chat-top,0px) + 8px)!important;bottom:auto!important;left:8px!important;right:8px!important;width:auto!important;height:calc(var(--hpm-chat-height,100dvh) - 16px)!important;max-height:calc(var(--hpm-chat-height,100dvh) - 16px)!important;min-height:0!important;transform:none!important;box-sizing:border-box!important}.panel__body{min-height:0!important;overflow:hidden!important}iframe[part~="iframe"]{zoom:1;width:100%!important;height:100%!important;min-height:0!important}}';
    target.appendChild(style);
  }
  function chatViewport() {
    const chat = document.querySelector('shopify-chat');
    if (!chat) return;
    chat.style.setProperty('--hpm-chat-height', `${window.visualViewport?.height || innerHeight}px`);
    chat.style.setProperty('--hpm-chat-top', `${window.visualViewport?.offsetTop || 0}px`);
    if (chat.classList.contains('hpm-chat-front')) readableChat(chat);
  }
  window.visualViewport?.addEventListener('resize', chatViewport);
  window.visualViewport?.addEventListener('scroll', chatViewport);
  window.addEventListener('resize', chatViewport);
  root.querySelector('[data-hpm-chat-open]').addEventListener('click', event => {
    const chat = document.querySelector('shopify-chat');
    const activator = chatActivator(chat);
    const status = root.querySelector('[data-hpm-chat-status]');
    status.hidden = Boolean(activator);
    if (!activator) return;
    // Do not let the opening click reach Shopify's outside-click closer.
    event.stopPropagation();
    close(false);
    readableChat(chat);
    chatObserver?.disconnect();
    chat.classList.add('hpm-chat-front');
    chatViewport();
    chatObserver = new MutationObserver(() => {
      const button = chatActivator(chat);
      chat.classList.toggle('hpm-chat-front', button?.getAttribute('aria-expanded') === 'true');
      readableChat(chat);
      const runtime = chat.shadowRoot?.querySelector('shopify-agent-runtime');
      if (runtime?.shadowRoot) chatObserver.observe(runtime.shadowRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
    });
    chatObserver.observe(chat.shadowRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
    const runtime = chat.shadowRoot.querySelector('shopify-agent-runtime');
    if (runtime?.shadowRoot) chatObserver.observe(runtime.shadowRoot, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
    if (runtime) runtime.setAttribute('open', '');
    else { activator.focus(); activator.click(); }
  });
  function close(restoreFocus = true) {
    if (overlay.hidden) return;
    overlay.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = previousOverflow;
    if (restoreFocus && previousFocus) previousFocus.focus();
  }
  trigger.addEventListener('click', () => {
    if (!mobile.matches) return;
    if (!overlay.hidden) { close(); return; }
    previousFocus = document.activeElement;
    previousOverflow = document.body.style.overflow;
    overlay.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-hpm-category-close]').focus();
  });
  root.querySelectorAll('[data-hpm-category-close]').forEach(button => button.addEventListener('click', () => close()));
  drawer.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close(false)));
  const tabs = [...drawer.querySelectorAll('[data-hpm-product-tab]')];
  const panels = [...drawer.querySelectorAll('[data-hpm-product-panel]')];
  function selectTab(selected, focus = false) {
    tabs.forEach(tab => {
      const active = tab === selected;
      tab.setAttribute('aria-selected', String(active));
      tab.tabIndex = active ? 0 : -1;
    });
    panels.forEach(panel => { panel.hidden = panel.id !== selected.getAttribute('aria-controls'); });
    if (focus) selected.focus();
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => selectTab(tab));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      selectTab(tabs[next], true);
    });
  });
  root.querySelector('[data-hpm-product-search]')?.addEventListener('submit', event => {
    const input = event.currentTarget.querySelector('input[name="q"]');
    input.value = input.value.trim();
    if (!input.value) { event.preventDefault(); input.focus(); return; }
    close(false);
  });
  drawer.querySelectorAll('.hpm-mobile-category-brands img').forEach(image => {
    const fallback = () => { image.parentElement.hidden = true; };
    image.addEventListener('error', fallback);
    if (image.complete && image.naturalWidth === 0) fallback();
  });
  document.addEventListener('keydown', event => {
    if (overlay.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); }
    if (event.key !== 'Tab') return;
    const items = [...drawer.querySelectorAll('a, button, input')].filter(element => !element.disabled && element.tabIndex >= 0 && element.getClientRects().length > 0);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  mobile.addEventListener('change', event => { if (!event.matches) close(false); });
  document.querySelectorAll('.hpm-member-mobile-menu a').forEach(link => link.addEventListener('click', () => {
    link.closest('details').open = false;
  }));
})();
